/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.publicAmazonCatalogue

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.publicAmazonCatalogue.PublicAmazonCatalogueApi
import features.publicAmazonCatalogue.models.PublicRewardsModel
import features.publicAmazonCatalogue.serializePublicAmazonCatalogueState



/**
 * Get a list of rewards available to all users including the amazon catalogue. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("PublicAmazonCatalogueApi")
class PublicAmazonCatalogueApiJs {

    /**
     * Get a list of rewards available to all users including the amazon catalogue.
     */
    fun getPublicAmazonCatalogue(
        overrideHeaders: String?, 
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = PublicAmazonCatalogueApi().getPublicAmazonCatalogue(
            overrideHeaders = decodedOverrideHeaders,
                        pageNumber = pageNumber,
            perPage = perPage,
            keywords = keywords,
            filters = filters
        ).toJsonResult<PublicRewardsModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observePublicAmazonCatalogueState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        PublicAmazonCatalogueApi().publicAmazonCatalogueState.serializePublicAmazonCatalogueState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
